var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center justify-content-center"},[_c('label',{staticClass:"mr-3",attrs:{"for":"all"}},[_vm._v("Select all")]),_vm._v(" "),_c('app-input',{attrs:{"type":"checkbox","list":[{ id: -1 }]},model:{value:(_vm.check),callback:function ($$v) {_vm.check=$$v},expression:"check"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }